var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 38,
    viewBox: "0 0 230 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0162 5.0127C33.2474 8.9465 34.3075 16.3607 30.3877 21.5779C26.4678 26.7951 19.0466 27.8274 13.8155 23.8936C11.1092 21.8639 10.5652 18.0208 12.6019 15.3145C13.2087 14.5054 13.9829 13.8917 14.8338 13.4801C8.99587 16.1306 6.30359 22.9589 8.8215 28.8736C11.3743 34.8789 18.3282 37.6619 24.3544 35.1021C27.0886 33.9373 29.5716 32.0611 31.4897 29.5153C37.2928 21.7872 35.7443 10.8227 28.0162 5.0127Z",
    fill: "url(#paint0_linear_3925_7296)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0163 5.01317C25.6449 3.22064 22.7782 2.01399 19.6117 1.63038C18.5724 1.50483 17.5471 1.46995 16.5427 1.52575C18.5445 2.19534 20.616 3.14391 22.2063 4.73417C27.3607 9.88857 26.9422 19.9742 21.1182 23.9359C19.9046 24.8287 18.3632 25.275 16.759 25.0798C15.7546 24.9542 14.8339 24.5985 14.0527 24.0614C19.2699 27.793 26.5237 26.7119 30.3878 21.5784C34.3146 16.3612 33.2475 8.94697 28.0163 5.01317Z",
    fill: "url(#paint1_linear_3925_7296)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82118 28.8739C6.35906 23.0848 8.88395 16.4099 14.4778 13.6478C16.6888 12.3296 19.8135 12.3575 22.7429 13.7176C21.1596 9.93025 17.6513 7.07754 13.2851 6.54745C6.81243 5.7593 0.918698 10.3836 0.130542 16.8842C-0.232149 19.8345 0.151467 22.9174 1.39996 25.8538C5.18729 34.7467 15.4612 38.8828 24.3541 35.0954C18.3348 37.6622 11.3809 34.8722 8.82118 28.8739Z",
    fill: "url(#paint2_linear_3925_7296)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.499 9H89.8164V11.3877H111.499V9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6804 26.6121V20.0459H107.127V17.6582H94.0914C91.7278 17.6582 89.8164 19.5696 89.8164 21.9331V28.9998H111.661V26.6121H92.6804Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.551 9H207.869V11.3877H229.551V9Z",
    fill: "#FD203C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210.733 26.6121V20.0459H225.18V17.6582H212.144C209.781 17.6582 207.869 19.5696 207.869 21.9331V28.9998H229.714V26.6121H210.733Z",
    fill: "#FD203C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.427 9H123.449V11.3877H145.427V9Z",
    fill: "#FD203C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.766 17.6582H127.731C125.367 17.6582 123.456 19.5696 123.456 21.9331V28.9998H126.32V20.0459H140.766V17.6582Z",
    fill: "#FD203C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.295 9H156.431V29H159.295V9Z",
    fill: "#FD203C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.002 13.9682V13.9561C195.002 11.2187 192.687 9.00586 189.497 9.00586H172.825V11.3936H188.785C190.986 11.3936 192.138 12.6658 192.138 14.3963V14.5229C192.138 16.5307 190.661 17.6583 188.629 17.6583H179.012H175.695H174.176H172.831V28.9998H175.695V20.0459H179.012H186.977H187.923C190.088 20.0459 191.842 21.4147 191.842 23.9652V28.9998H194.706V24.4596C194.706 21.3001 193.302 19.5395 189.913 19.5395L189.895 18.4542C192.873 18.4542 195.002 16.6634 195.002 13.9682Z",
    fill: "#FD203C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7493 9H63.8774H54.001V29H63.8774H68.7493C74.2663 29 77.6549 24.5261 77.6549 19.003C77.6549 13.4799 74.2663 9 68.7493 9ZM68.2428 26.6123H63.8774H56.865V11.3877H63.8774H68.2428C72.8554 11.3877 74.8451 14.7944 74.8451 18.997C74.8451 23.1996 72.6685 26.6123 68.2428 26.6123Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3925_7296",
    x1: 33.2981,
    y1: 17.5371,
    x2: 3.44077,
    y2: 24.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE273B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502869,
    stopColor: "#AD1A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3925_7296",
    x1: 10.3724,
    y1: 20.0222,
    x2: 30.4065,
    y2: 7.81165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE273B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#520E15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3925_7296",
    x1: 25.9555,
    y1: 37.2911,
    x2: 3.30865,
    y2: 8.98252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE273B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#FE273B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#540F15"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.327b1bf284d3f2615ea55413aecd5cce.svg";
export { ForwardRef as ReactComponent };